import { FC, useMemo } from 'react';
import { useFetchPricePlans } from 'lib/hooks';
import { MORE } from 'constants/shared/routes';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import ManageSubscription from '../presentational/ManageSubscription';
import useTranslate from 'lib/languages/useTranslate';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import { useGetAccountQuery } from 'lib/services';
import { PricePlan, ProductClassCode } from 'lib/type';

const ManageSubscriptionContainer: FC = () => {
    const translate = useTranslate('pricePlan');
    const { data: account, isLoading, error } = useGetAccountQuery();
    const {
        pricePlans,
        isFetching: isFetchingPricePlans,
        error: pricePlansError,
    } = useFetchPricePlans();

    const sanitizedPricePlans = useMemo(() => {
        if (!pricePlans) return undefined;

        return pricePlans.map(
            (plan): PricePlan => ({
                ...plan,
                productClassCode: plan.productClassCode as ProductClassCode,
                perks: plan.perks.map(perk => ({
                    ...perk,
                    description: perk.description ?? '',
                })),
            }),
        );
    }, [pricePlans]);

    return (
        <PageContainer className="more-manage-subscription-container">
            <SectionTitle
                title={translate('breadcrumbText')}
                backRoute={MORE}
            />
            <DataCheck
                data={account && sanitizedPricePlans}
                isLoading={isLoading || isFetchingPricePlans}
                error={error || pricePlansError}
                noDataMessage={translate('noDataMessage')}
            >
                {account && sanitizedPricePlans && (
                    <ManageSubscription
                        productType={account.productType}
                        pricePlans={sanitizedPricePlans}
                    />
                )}
                <p className="disclaimer">{translate('disclaimer')}</p>
            </DataCheck>
        </PageContainer>
    );
};

export default ManageSubscriptionContainer;
